module.exports = __webpack_public_path__ + "static/img/6.c8fa03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/6.png
// module id = qIdq
// module chunks = 0